import { EnvironmentProviders } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import type { ToastConfig } from '@ngxpert/hot-toast';

const TOAST_DEFAULTS: Partial<ToastConfig> = {
  position: 'bottom-right',
  duration: 2000,
  dismissible: true,
};

/**
 * Registers the standard ONRSR UI application providers, including the
 * global toast defaults (bottom-right, 2s, dismissible).
 *
 * Spread into `ApplicationConfig.providers`:
 *
 * ```ts
 * providers: [
 *   provideRouter(routes),
 *   ...provideOnrsrUi(),
 * ]
 * ```
 */
export function provideOnrsrUi(): EnvironmentProviders[] {
  return [provideAnimationsAsync(), provideHotToastConfig(TOAST_DEFAULTS)];
}

/**
 * Overrides the global toast defaults app-wide. Optional — merge over the
 * defaults and place after `...provideOnrsrUi()`:
 *
 * ```ts
 * providers: [
 *   ...provideOnrsrUi(),
 *   provideOnrsrToastConfig({ position: 'top-center', duration: 4000 }),
 * ]
 * ```
 */
export function provideOnrsrToastConfig(config: Partial<ToastConfig>): EnvironmentProviders {
  return provideHotToastConfig({ ...TOAST_DEFAULTS, ...config });
}
